import { getFeatureSetting } from "../../feature-settings";
import { SpecialValueKind } from "../description";

export interface SpecialValueDescriptor {
    readonly kind: SpecialValueKind;
    readonly label: string;
    readonly description: string;
    readonly img: string;
    readonly isNew?: boolean;
}

const baseSpecialValueDescriptors: readonly SpecialValueDescriptor[] = [
    {
        kind: SpecialValueKind.Timestamp,
        label: "Current date/time",
        description: "The date/time at form submission",
        img: "componentDateTime",
    },
    {
        kind: SpecialValueKind.UniqueIdentifier,
        label: "Unique identifier",
        description: "A unique value",
        img: "componentUniqueID",
        isNew: false,
    },
    {
        kind: SpecialValueKind.VerifiedEmailAddress,
        label: "User's email address",
        description: "The email address of the app's user",
        img: "componentEmail",
    },
];

export function getSpecialValueDescriptors(
    withDeepLink: boolean,
    withActionSource: boolean,
    withClearColumn: boolean
): readonly SpecialValueDescriptor[] {
    const descrs = [...baseSpecialValueDescriptors];
    if (withDeepLink && getFeatureSetting("deepLinks")) {
        descrs.push({
            kind: SpecialValueKind.CurrentURL,
            label: "Link to current screen",
            description: "The URL of the current screen",
            img: "headerUri",
        });
    }
    if (withActionSource) {
        descrs.push({
            kind: SpecialValueKind.ActionSource,
            label: "Action source",
            description: "An identifier for the source of the action",
            img: "componentSeparator",
        });
    }
    if (withClearColumn) {
        descrs.push({
            kind: SpecialValueKind.ClearColumn,
            label: "Clear value",
            description: "Clear out the value in the column",
            // FIXME: Proper icon
            img: "componentSeparator",
        });
    }
    return descrs;
}

export function findSpecialValueDescriptor(kind: SpecialValueKind): SpecialValueDescriptor | undefined {
    return getSpecialValueDescriptors(true, true, true).find(i => i.kind === kind);
}
